import { type AxiosRequestConfig } from 'axios'

const requestEventsPermission = (): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: `/events/permission`
  }
}

export { requestEventsPermission }
